// Uploading a file to itinerary involves 3 separate steps:
// 1. get a URL
// 2. upload the file to the URL
// 3. tell itinerary manager to process what we just uploaded
// 3.5: get the JSON response from that process; thats what we put in our payload to save

import { useState } from 'react';
import { ENetworkRequestStatus } from 'services/BackendApi';
import { makeItineraryManagerApi } from 'services/ItineraryManagerApi';

export const useItineraryUploader = (bookingUuid: string) => {
  const itineraryManager = makeItineraryManagerApi();
  const [requestStatus, setRequestStatus] = useState<ENetworkRequestStatus>(ENetworkRequestStatus.IDLE);
  const uploadAndProcessFile = async ({
    file,
    displayName,
    fileType,
  }: {
    file: File;
    displayName: string;
    fileType: 'image' | 'file';
  }) => {
    const contentType = file.type;
    const fileName = file.name;
    setRequestStatus(ENetworkRequestStatus.PENDING);

    try {
      // step 1 get a URL
      const getUrlResponse = await itineraryManager.getUploadUrl({ bookingUuid, fileName, contentType });

      // step 2 upload the file to the URL
      const { url, filePath } = getUrlResponse.data;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('contentType', contentType);
      await fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': contentType,
        },
      });
      // step 3 tell itinerary manager to process what we just uploaded
      const processUploadResponse = await itineraryManager.postProcessUpload({
        bookingUuid,
        displayName,
        filePath,
        fileType,
      });

      setRequestStatus(ENetworkRequestStatus.SUCCESS);
      return processUploadResponse.data;
    } catch (e) {
      setRequestStatus(ENetworkRequestStatus.ERROR);
      return null;
    }
    // step 3.5 return the output
  };

  return {
    requestStatus,
    uploadAndProcessFile,
  };
};
